"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionManager = void 0;
const types_1 = require("./types");
const count_down_timer_1 = require("./count-down-timer");
const utils_common_1 = require("@agilepoint/utils-common");
/**
 * Method to convert minutes into ticks(ms)
 * @param timeout In seconds
 */
function getTicks(timeout) {
    return timeout * 1000;
}
/**
 * Method to convert minutes into ticks(ms)
 * @param timeout In seconds
 */
function getExpiryTime(timeout) {
    const now = new Date();
    return (now.getTime() + getTicks(timeout));
}
const defaultIsTokenValid = (token) => (utils_common_1.isString(token) && token.length > 3);
class SessionManager {
    constructor(options) {
        this.options = options;
        this.onWarn = () => {
            const { onWarn } = this.options;
            this.sessionState = types_1.SessionState.warning;
            if (onWarn === undefined) {
                return;
            }
            onWarn();
        };
        this.onExpire = () => {
            const { onExpire } = this.options;
            this.clear();
            if (onExpire === undefined) {
                return;
            }
            onExpire();
        };
        const { warningTimeout, staySignedInFor } = options;
        this.timer = new count_down_timer_1.CountDownTimer({
            timeout: utils_common_1.isNumber(staySignedInFor) ? getTicks(staySignedInFor) : undefined,
            warningTimeout: utils_common_1.isNumber(warningTimeout) ? getTicks(warningTimeout) : undefined,
            onEnd: this.onExpire,
            onWarn: this.onWarn
        });
        this.sessionState = types_1.SessionState.disabled;
    }
    clear() {
        this.timer.clear();
        this.sessionState = types_1.SessionState.expired;
    }
    async start() {
        const { getToken } = this.options;
        const { auth, expires } = await getToken();
        this.authInfo = { auth, expires: getExpiryTime(expires) };
        this.timer.start();
        this.sessionState = types_1.SessionState.active;
    }
    resetTimer() {
        if (this.sessionState === types_1.SessionState.active || this.sessionState === types_1.SessionState.warning) {
            this.timer.reset();
        }
    }
    async getAuthToken() {
        const { renewToken } = this.options;
        if (!(await this.isSessionValid())) {
            const { auth, expires } = await renewToken();
            this.authInfo = { auth, expires: getExpiryTime(expires) };
            this.timer.start();
            this.sessionState = types_1.SessionState.active;
        }
        return this.authInfo.auth;
    }
    async isSessionValid() {
        if (!this.authInfo || this.sessionState !== types_1.SessionState.active) {
            return false;
        }
        const now = new Date();
        const { isTokenValid } = this.options;
        const { expires, auth } = this.authInfo;
        if (expires > 0 && now.getTime() > expires) {
            this.clear();
            return false;
        }
        return utils_common_1.isFunction(isTokenValid) ? isTokenValid(auth) : defaultIsTokenValid(auth);
    }
}
exports.SessionManager = SessionManager;
//# sourceMappingURL=session-manager.js.map